import React, { useState, useEffect } from "react";
import { useColors } from "../../../contexts/ColorContext";
import { Card, Form, Button } from "react-bootstrap";
import api from "../../../services/api";
import Cookies from "js-cookie";
import { BASE_URL } from "../../../config";

export default function Configuracoes({ usuario }) {
  const { colors } = useColors();
  const { cardBackgroundColor, cardTextColor, buttonColor, buttonTextColor } = colors;

  const [form, setForm] = useState({
    nome: "",
    celular: "",
    senha: "",
    dtInicioAlmoco: "",
    dtFimAlmoco: "",
  });

  const [temAlmoco, setTemAlmoco] = useState(false);
  const [imagemUrl, setImagemUrl] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    if (usuario) {
      setForm({
        nome: usuario.nome || "",
        celular: usuario.celular || "",
        senha: "",
        dtInicioAlmoco: usuario.dtInicioAlmoco || "",
        dtFimAlmoco: usuario.dtFimAlmoco || "",
      });

      setTemAlmoco(!!usuario.dtInicioAlmoco && !!usuario.dtFimAlmoco);

      setImagemUrl(`${BASE_URL}/api/Funcionarios/${usuario.id}/image`);
    }
  }, [usuario]);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const uploadImage = async () => {
    if (!selectedFile) return usuario.id;

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      await api.post(
        `/Funcionarios/${usuario.id}/upload-image`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      return usuario.id;
    } catch (error) {
      console.error("Erro ao fazer upload da imagem:", error);
      window.globalAlert("Erro ao fazer upload da imagem.", "error");
      return usuario.id;
    }
  };

  const salvar = async () => {
    try {
      await uploadImage();

      const updateData = {
        nome: form.nome,
        celular: form.celular,
        senha: form.senha || undefined,
        dtInicioAlmoco: temAlmoco ? form.dtInicioAlmoco : null,
        dtFimAlmoco: temAlmoco ? form.dtFimAlmoco : null,
      };

      await api.put(`/Funcionarios/${usuario.id}`, updateData);

      const updatedUser = { ...usuario, ...updateData };
      Cookies.set("usuario", JSON.stringify(updatedUser), { expires: 7 });

      setImagemUrl(`${BASE_URL}/api/Funcionarios/${usuario.id}/image?t=${Date.now()}`);
      setForm((prevForm) => ({ ...prevForm, senha: "" }));
      setSelectedFile(null);

      window.globalAlert("Configurações salvas com sucesso!", "success");
    } catch (error) {
      console.error("Erro ao salvar configurações:", error);
      window.globalAlert("Erro ao salvar configurações.", "error");
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-start w-100">
      <Card className="p-4 shadow-sm w-100" style={{ backgroundColor: cardBackgroundColor, color: cardTextColor }}>
        <h5>Configurações do Perfil</h5>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Nome</Form.Label>
            <Form.Control
              type="text"
              value={form.nome}
              onChange={(e) => setForm({ ...form, nome: e.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Celular</Form.Label>
            <Form.Control
              type="text"
              value={form.celular}
              onChange={(e) => setForm({ ...form, celular: e.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Nova Senha</Form.Label>
            <Form.Control
              type="password"
              value={form.senha}
              onChange={(e) => setForm({ ...form, senha: e.target.value })}
            />
          </Form.Group>

          <div className="mb-3 form-check">
            <Form.Check
              type="checkbox"
              label="Deseja definir horário de almoço?"
              checked={temAlmoco}
              onChange={(e) => setTemAlmoco(e.target.checked)}
            />
          </div>

          {temAlmoco && (
            <div className="row">
              <Form.Group className="mb-3 col-md-6">
                <Form.Label>Início do Almoço</Form.Label>
                <Form.Control
                  type="time"
                  value={form.dtInicioAlmoco}
                  onChange={(e) => setForm({ ...form, dtInicioAlmoco: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-6">
                <Form.Label>Fim do Almoço</Form.Label>
                <Form.Control
                  type="time"
                  value={form.dtFimAlmoco}
                  onChange={(e) => setForm({ ...form, dtFimAlmoco: e.target.value })}
                />
              </Form.Group>
            </div>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Foto de Perfil</Form.Label>
            {usuario.id && (
              <div className="mb-2">
                <img
                  src={imagemUrl}
                  alt="Foto de Perfil"
                  style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "50%" }}
                />
              </div>
            )}
            <Form.Control
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
            <Form.Text className="text-muted">
              Selecione uma nova imagem para atualizar sua foto de perfil.
            </Form.Text>
          </Form.Group>

          <Button
            variant="primary"
            onClick={salvar}
            style={{ backgroundColor: buttonColor, borderColor: buttonColor, color: buttonTextColor }}
          >
            Salvar Alterações
          </Button>
        </Form>
      </Card>
    </div>
  );
}
